module.exports = __webpack_public_path__ + "images/emoji/sagittarius.05f9cea02091278dda0c.png";